<template>
  <div>
    <topnavbar></topnavbar>
    <navigation></navigation>
    <div id="page-wrapper" class="gray-bg" style="margin-top:60px">
      <div>
        <breadcrumb></breadcrumb>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import topnavbar from "../components/common/topnavbar";
import navigation from "../components/common/navigation";
import breadcrumb from "../components/common/breadcrumb";

export default {
  name: "homeController",
  components: {
    topnavbar,
    navigation,
    breadcrumb
  },
  data() {
    return {};
  },
  created: () => {},
  methods: {},
  mounted: function() {
  }
};
</script>
<style>
.theme-green .vdatetime-popup__header,
.theme-green .vdatetime-calendar__month__day--selected > span > span,
.theme-green .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #1ab394;
}

.theme-green .vdatetime-year-picker__item--selected,
.theme-green .vdatetime-time-picker__item--selected,
.theme-green .vdatetime-popup__actions__button {
  color: #1ab394;
}
</style>